import React, { useEffect, useState } from 'react';
import api from '../../services/api';
import { toast } from 'react-toastify';

const fmt = (n) => new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', maximumFractionDigits: 0 }).format(n || 0);
const EST_COLORS = { pagado: '#34d399', pendiente: '#fbbf24', fallido: '#f87171', reembolsado: '#94a3b8' };

export default function AdminPagos() {
  const [pagos, setPagos] = useState([]);
  const [total, setTotal] = useState(0);
  const [totalPagado, setTotalPagado] = useState(0);
  const [loading, setLoading] = useState(true);
  const [estadoFiltro, setEstadoFiltro] = useState('');
  const [modal, setModal] = useState(false);

  const cargar = () => {
    const params = estadoFiltro ? `?estado=${estadoFiltro}` : '';
    api.get(`/admin/pagos${params}`).then(r => {
      setPagos(r.data.pagos);
      setTotal(r.data.total);
      setTotalPagado(r.data.total_pagado);
    }).finally(() => setLoading(false));
  };
  useEffect(cargar, [estadoFiltro]);

  return (
    <div style={{ padding: 28 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <div>
          <h1 style={{ margin: 0, fontSize: 22, fontWeight: 700, color: 'var(--text-1)' }}>Pagos y Facturación</h1>
          <p style={{ margin: '4px 0 0', color: 'var(--text-3)', fontSize: 14 }}>
            Total cobrado: <strong style={{ color: '#34d399' }}>{fmt(totalPagado)}</strong>
            <span style={{ marginLeft: 16 }}>{total} registros</span>
          </p>
        </div>
        <button onClick={() => setModal(true)} style={{ padding: '9px 20px', borderRadius: 8, border: 'none', background: '#6366f1', color: '#fff', cursor: 'pointer', fontWeight: 600, fontSize: 14 }}>
          + Registrar Pago
        </button>
      </div>

      {/* Filters */}
      <div style={{ display: 'flex', gap: 10, marginBottom: 20 }}>
        {['', 'pagado', 'pendiente', 'fallido', 'reembolsado'].map(e => (
          <button key={e} onClick={() => setEstadoFiltro(e)}
            style={{ padding: '8px 16px', borderRadius: 8, border: 'none', cursor: 'pointer', fontSize: 13,
              background: estadoFiltro === e ? '#6366f1' : '#1e293b',
              color: estadoFiltro === e ? '#fff' : '#64748b'
            }}
          >{e || 'Todos'}</button>
        ))}
      </div>

      {loading ? (
        <div style={{ textAlign: 'center', color: 'var(--text-3)', padding: 60 }}>Cargando...</div>
      ) : (
        <div style={{ background: 'var(--bg-card)', borderRadius: 12, border: '1px solid var(--border)', overflow: 'hidden' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: 'var(--bg-app)' }}>
                {['Fecha','Empresa','Concepto','Monto','Método','Referencia','Estado'].map(h => (
                  <th key={h} style={{ padding: '12px 16px', textAlign: 'left', fontSize: 11, fontWeight: 600, color: 'var(--text-3)', textTransform: 'uppercase', letterSpacing: 0.5 }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {pagos.map(p => (
                <tr key={p.id} style={{ borderTop: '1px solid var(--border)' }}>
                  <td style={{ padding: '12px 16px', color: 'var(--text-2)', fontSize: 12 }}>{p.fecha}</td>
                  <td style={{ padding: '12px 16px' }}>
                    <div style={{ color: 'var(--text-1)', fontSize: 13, fontWeight: 500 }}>{p.empresa}</div>
                    <div style={{ color: 'var(--text-3)', fontSize: 11 }}>{p.cliente_email}</div>
                  </td>
                  <td style={{ padding: '12px 16px', color: 'var(--text-2)', fontSize: 13 }}>{p.concepto || '-'}</td>
                  <td style={{ padding: '12px 16px', color: '#22d3ee', fontWeight: 700, fontSize: 14 }}>{fmt(p.monto)}</td>
                  <td style={{ padding: '12px 16px', color: 'var(--text-2)', fontSize: 12, textTransform: 'capitalize' }}>{p.metodo}</td>
                  <td style={{ padding: '12px 16px', color: 'var(--text-3)', fontSize: 12 }}>{p.referencia || '-'}</td>
                  <td style={{ padding: '12px 16px' }}>
                    <span style={{ fontSize: 11, padding: '2px 10px', borderRadius: 20, background: (EST_COLORS[p.estado] || '#64748b') + '22', color: EST_COLORS[p.estado] || '#64748b' }}>{p.estado}</span>
                  </td>
                </tr>
              ))}
              {!pagos.length && (
                <tr><td colSpan={7} style={{ padding: 40, textAlign: 'center', color: 'var(--text-4)' }}>No hay pagos</td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      {modal && <PagoModal onClose={() => setModal(false)} onSaved={() => { setModal(false); cargar(); }} />}
    </div>
  );
}

function PagoModal({ onClose, onSaved }) {
  const [clientes, setClientes] = useState([]);
  const [suscripciones, setSuscripciones] = useState([]);
  const [form, setForm] = useState({ cliente_id: '', suscripcion_id: '', monto: '', fecha: new Date().toISOString().split('T')[0], metodo: 'transferencia', referencia: '', concepto: '', estado: 'pagado' });
  const [saving, setSaving] = useState(false);
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const inputStyle = { width: '100%', padding: '9px 12px', borderRadius: 8, border: '1px solid var(--border)', background: 'var(--bg-app)', color: 'var(--text-1s)', fontSize: 13, outline: 'none', boxSizing: 'border-box' };

  useEffect(() => { api.get('/admin/clientes').then(r => setClientes(r.data)).catch(() => {}); }, []);

  useEffect(() => {
    if (form.cliente_id) {
      api.get(`/admin/suscripciones/cliente/${form.cliente_id}`).then(r => {
        setSuscripciones(r.data);
        const act = r.data.find(s => s.estado === 'activo');
        if (act) { set('suscripcion_id', act.id); set('monto', act.precio_pactado); }
      }).catch(() => {});
    }
  }, [form.cliente_id]);

  const guardar = async () => {
    if (!form.cliente_id || !form.monto) return toast.error('Cliente y monto son requeridos');
    setSaving(true);
    try {
      await api.post('/admin/pagos', { ...form, monto: Number(form.monto) });
      toast.success('Pago registrado');
      onSaved();
    } catch (e) {
      toast.error(e.response?.data?.error || 'Error');
    } finally { setSaving(false); }
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: '#00000080', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 20 }}>
      <div style={{ background: 'var(--bg-card)', borderRadius: 16, padding: 28, width: '100%', maxWidth: 520, border: '1px solid var(--border)' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 22 }}>
          <h2 style={{ margin: 0, fontSize: 17, color: 'var(--text-1)' }}>Registrar Pago</h2>
          <button onClick={onClose} style={{ background: 'none', border: 'none', color: 'var(--text-3)', cursor: 'pointer', fontSize: 20 }}>×</button>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
          <div style={{ gridColumn: '1/-1' }}>
            <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>Cliente *</label>
            <select style={inputStyle} value={form.cliente_id} onChange={e => set('cliente_id', e.target.value)}>
              <option value="">Seleccionar cliente...</option>
              {clientes.map(c => <option key={c.id} value={c.id}>{c.empresa}</option>)}
            </select>
          </div>
          {suscripciones.length > 0 && (
            <div style={{ gridColumn: '1/-1' }}>
              <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>Suscripción</label>
              <select style={inputStyle} value={form.suscripcion_id} onChange={e => { set('suscripcion_id', e.target.value); const s = suscripciones.find(x => String(x.id) === e.target.value); if (s) set('monto', s.precio_pactado); }}>
                <option value="">Sin suscripción</option>
                {suscripciones.map(s => <option key={s.id} value={s.id}>{s.plan_nombre} · {s.estado}</option>)}
              </select>
            </div>
          )}
          <div>
            <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>Monto *</label>
            <input style={inputStyle} type="number" value={form.monto} onChange={e => set('monto', e.target.value)} />
          </div>
          <div>
            <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>Fecha *</label>
            <input style={inputStyle} type="date" value={form.fecha} onChange={e => set('fecha', e.target.value)} />
          </div>
          <div>
            <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>Método</label>
            <select style={inputStyle} value={form.metodo} onChange={e => set('metodo', e.target.value)}>
              {['transferencia','tarjeta','nequi','daviplata','efectivo','otro'].map(m => <option key={m} value={m}>{m}</option>)}
            </select>
          </div>
          <div>
            <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>Estado</label>
            <select style={inputStyle} value={form.estado} onChange={e => set('estado', e.target.value)}>
              {['pagado','pendiente','fallido','reembolsado'].map(s => <option key={s} value={s}>{s}</option>)}
            </select>
          </div>
          <div>
            <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>Referencia</label>
            <input style={inputStyle} value={form.referencia} onChange={e => set('referencia', e.target.value)} placeholder="TRF-001" />
          </div>
          <div>
            <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>Concepto</label>
            <input style={inputStyle} value={form.concepto} onChange={e => set('concepto', e.target.value)} placeholder="Suscripción mensual..." />
          </div>
        </div>

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 22 }}>
          <button onClick={onClose} style={{ padding: '9px 18px', borderRadius: 8, border: '1px solid var(--border)', background: 'transparent', color: 'var(--text-2)', cursor: 'pointer', fontSize: 13 }}>Cancelar</button>
          <button onClick={guardar} disabled={saving} style={{ padding: '9px 20px', borderRadius: 8, border: 'none', background: '#6366f1', color: '#fff', cursor: 'pointer', fontWeight: 600, fontSize: 13 }}>{saving ? 'Guardando...' : 'Registrar Pago'}</button>
        </div>
      </div>
    </div>
  );
}
